<div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 size">
    <!--  <div mat-flat-button class="formclose" align="right" (click)="closeUserconfigForm()"><img src="assets/img/icons/forma-11.png"></div> -->
    <mat-card-header>
        <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
            <div mat-flat-button class="formclose" align="right" (click)="closeUserconfigForm()">
                <img src="assets/img/icons/forma-11.png">
            </div>
            </div>

        <mat-card-title>
                <mat-label class="headLabel"> Configure </mat-label>
            </mat-card-title>
            
        
</mat-card-header>

    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" style="padding-left:5px">

        <!-- <input class="form-control" type="text" name="search" [(ngModel)]="searchText" autocomplete="off" placeholder="&#61442; "> -->
        <form [formGroup]="Userconfig" class="example-form">


            <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                <div class="col-sm-12 col-xs-12 col-md-6 col-lg-6" style="padding-left: 0px">
                    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">User case </div>
                    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                        <mat-form-field appearance="outline" class="example-full-width" style="width:100%">
                            <input (keypress)="numberOnly($event)" matInput formControlName="userCases" value="">
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-sm-12 col-xs-12 col-md-6 col-lg-6" style="padding-right: 0px">
                    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">User Repository</div>
                    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                        <mat-form-field appearance="outline" class="example-full-width" style="width:100%">
                            <input (keypress)="numberOnly($event)" matInput formControlName="userRepository" value="">
                        </mat-form-field>
                    </div>
                </div>
            </div>


            <!-- <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                    <div class="col-sm-12 col-xs-12 col-md-6 col-lg-6" style="padding-left: 0px">
                        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">Case Monitoring</div>
                        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                            <mat-form-field appearance="outline" class="example-full-width" style="width:100%">
                                <input (keypress)="numberOnly($event)" matInput formControlName="casesMonitoring" value="">
                            </mat-form-field>
                        </div>
                    </div>



                    <div class="col-sm-12 col-xs-12 col-md-6 col-lg-6" style="padding-right: 0px">
                        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">Email Account </div>
                        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                            <mat-form-field appearance="outline" class="example-full-width" style="width:100%">
                                <input (keypress)="numberOnly($event)" matInput formControlName="emailAccount" value="">
                            </mat-form-field>
                        </div>
                    </div>
                </div> -->

            <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                <div class="col-sm-12 col-xs-12 col-md-6 col-lg-6">
                    <div style="padding-top:5px">Admin Repository</div>

                    <mat-form-field style="width:100%">
                        <input matInput placeholder="Search" (keyup)="configFilter($event.target.value)">
                    </mat-form-field>

                    <div *ngFor="let adminRepository of AdminRepository" >
                        <mat-checkbox class="EntityList" (change)="repositoryChange($event.checked,adminRepository.templateName)"
                                      [checked]="checkedadminRepository(adminRepository.templateName)">{{adminRepository.templateName}}</mat-checkbox>
                    </div>

                </div>


                <!-- <div class="col-sm-12 col-xs-12 col-md-6 col-lg-6" style="padding-right: 0px">
                    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" style="padding-top:5px">Admin Entity Analytics</div>
                    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                        <mat-form-field style="width:100%">
                            <mat-label style="padding-right: 0px">Search</mat-label>
                            <input matInput type="text">
                        </mat-form-field>

                        <div *ngFor="let adminEntityAnalytics of AdminEntityAnalytics">
                            <mat-checkbox class="EntityList" (change)="analyticsChange($event.checked,adminEntityAnalytics)" [checked]="checkedadminEntityAnalytics(adminEntityAnalytics)">{{adminEntityAnalytics}}</mat-checkbox>
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                <button [disabled]="!Userconfig.valid " mat-flat-button class="btn "
                    (click)="createUserconfig()">Save</button>
            </div>
        </form>
    </div>
</div>